import {ProtocolCommand} from "../service-model/protocol-command.interface";
import {ProtocolQuery} from "../service-model/protocol-query.interface";
import {SHELL_PROTOCOL_OPERATIONS_NS} from "../shell-communication/operations/shell-protocol-namespace.const";

export class GetCurrentQuoteRateShell implements ProtocolQuery {
    getOperationName(): string {
        return `${SHELL_PROTOCOL_OPERATIONS_NS}.GetCurrentQuoteRateShell`;
    }
}

export interface GetCurrentQuoteRateShellReply {
    rate: number;
    throttledRate: number;
    mode: 'Mode 1' | 'Mode 2' | 'Mode 3';
}

export interface QuoteRateThrottlingSettings {
    currentMode?: 'Mode 1' | 'Mode 2' | 'Mode 3';
    isManualModeSwitch?: boolean;
    mode2Rate?: number;
    mode3Rate?: number;
    mode1Threshold?: number;
    mode2Threshold?: number;

    // UI only
    visibleRateKind?: 'Raw' | 'Mode-based';
    manualMode?: string;
}

export class GetThrottlingSettingsShell implements ProtocolQuery {
    getOperationName(): string {
        return `${SHELL_PROTOCOL_OPERATIONS_NS}.GetThrottlingSettingsShell`;
    }
}


export class SaveQuoteRateThrottlingSettingsShell implements ProtocolCommand {
    constructor(
        public settings: QuoteRateThrottlingSettings
    ) {
    }
    getOperationName(): string {
        return `${SHELL_PROTOCOL_OPERATIONS_NS}.SaveQuoteRateThrottlingSettingsShell`;
    }

}